import React from "react";
import MotherAndKids from "../../../forms/mother&kid";
// import TextField from "@material-ui/core/TextField";
import Talks from "../../../forms/goftegoo";
import Adults from "../../../forms/adults";
import Books from "../../../forms/book";
import KidsHouse from "../../../forms/kidshouse";
import SingleWorkshop from "../../../forms/singleWorkshop";

export default function SetUserInfo(props) {
  const {mode, SubmitData, ActivateNext , GetStepData} = props;

  const NextActive = (stat) => {
    ActivateNext(stat);
  };
  
  const args = {
    HandleData: SubmitData,
    NextBtn: NextActive,
    ModeData: GetStepData
  };


  const Forms = [
    <Adults HandleData={SubmitData} NextBtn={NextActive}/>,
    <Books HandleData={SubmitData}  NextBtn={NextActive}/>,
    <Talks HandleData={SubmitData}  NextBtn={NextActive}/>,
    <MotherAndKids HandleData={SubmitData} NextBtn={NextActive}/>,
    <KidsHouse {...args} />,
    <SingleWorkshop {...args} />  
  ];
  return <div>{Forms[mode()]}</div>;
}
